
import { Component, Vue, Prop } from 'vue-property-decorator'
import axios from 'axios'

@Component({
  name: 'version',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private id!: any
  private listLoading = false
  private list: any[] = []
  private total = 0

  private url: string =
    'https://dapi.paypptp.com/api/manage/open-plugin/' +
    this.id +
    '/open-version'

  private queryForm: any = {
    version: ''
  }

  private select () {
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.queryForm.version = ''
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      axios
        .get(this.url, {
          params: {
            id: this.id,
            version: this.queryForm.version,
            page_size: this.pagesize,
            page: this.currentPage
          }
        })
        .then((res: any) => {
          this.total = res.data.count
          this.list = res.data.results
          this.listLoading = false
        })
        .catch(() => {
          this.list = []
          this.listLoading = false
        })
    } catch (e) {
      this.listLoading = false
    }
  }

  private jump (row: any) {
    window.open(row)
  }

  mounted () {
    this.hadleGetFilesListApi()
  }
}
